import api from './Api';

export interface AdminUser {
  id: number;
  username: string;
  email: string;
  role: string;
  firstLogin?: boolean;
  fullName?: string;
  phone?: string;
  active?: boolean;
}

export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  role: string;
  firstLogin?: boolean;
  fullName?: string;
  phone?: string;
}

export interface UpdateRoleRequest {
  role: string;
}

export interface AdminUserStatisticsSummary {
  userId: number;
  username: string;
  role: string;
  addedProducts: number;
  soldProducts: number;
  earnedMoney: number;
  transactionsCount: number;
}

export interface AdminUserProductStatistics {
  productId: number;
  name: string;
  firm?: string;
  model?: string;
  size?: string;
  added: number;
  sold: number;
  earned: number;
}

export interface AdminUserFullStatistics {
  userId: number;
  username: string;
  role: string;
  addedProducts: number;
  soldProducts: number;
  earnedMoney: number;
  transactionsCount: number;
  byType: Record<string, number>;
  byProduct: AdminUserProductStatistics[];
}

export interface AdminCompany {
  id: number;
  name: string;
  location?: string;
}

export const AdminUserApi = {
  // Get all users (admin only)
  getAll: () =>
    api.get<AdminUser[]>('/admin/users'),

  // Create user (admin only)
  create: (user: CreateUserRequest) =>
    api.post<AdminUser>('/admin/users', user),

  // Delete user (admin only)
  delete: (userId: number) =>
    api.delete(`/admin/users/${userId}`),

  // Update user role (admin only)
  updateRole: (userId: number, role: string) =>
    api.put<AdminUser>(`/admin/users/${userId}/role`, { role }),

  // Toggle user active/inactive (admin only)
  toggleActive: (userId: number) =>
    api.patch<{ active: boolean }>(`/admin/users/${userId}/active`),

  // Get user by ID (admin only)
  getById: (userId: number) =>
    api.get<AdminUser>(`/admin/users/${userId}`),

  // Get companies assigned to a specific user (admin only)
  getUserCompanies: (userId: number) =>
    api.get<AdminCompany[]>(`/admin/users/${userId}/companies`),

  // Get summary statistics for all users (admin only)
  getAllUserStatistics: () =>
    api.get<AdminUserStatisticsSummary[]>('/admin/users/statistics', { suppressGlobalError: true }),

  // Get full statistics for one user (admin only)
  getUserFullStatistics: (userId: number) =>
    api.get<AdminUserFullStatistics>(`/admin/users/${userId}/statistics`, { suppressGlobalError: true }),
};
